var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center flex-column mt-10"},[_c('div',{staticClass:"h2"},[_vm._v("Loading the login page...")]),_c('v-btn',{staticClass:"text-none",attrs:{"text":"","small":"","loading":_vm.loggedIn,"disabled":_vm.loggedIn},on:{"click":_vm.login}},[_vm._v("Take me there!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }